import request from 'utils/request'

// 获取列表数据
export const getTableData = data => request().post('card/page', data)

// 删除
export const remove = id => request().get(`card/delete/${id}`)

// 冻结
export const freeze = id => request().get(`card/freeze/${id}`)

// 解冻
export const thaw = id => request().get(`card/thaw/${id}`)

// 添加
export const add = data => request().post('card/add', data)

// 编辑
export const update = data => request().post('card/update', data)

// 获取指标列表
export const getTargetTreeList = () =>
  request().post('card/customTargetChoose/list')

//获取选择指标下拉选列表
export const getChooseList = data =>
  request().post('card/targetChooseItemList/list', data)

// 获取业务类型列表
export const getFreezeBgList = () =>
  request().get('business/jsonList/getFreezeBgList')

// 自定义评分详情
export const detail = id => request().get(`card/info/${id}`)

//获取自定义评分卡被引用次数数据列表
export const getUsedData = cardId =>
  request().post(`card/getUsedData/list/${cardId}`)
